import { render, staticRenderFns } from "./UploadOrRecordVideo.vue?vue&type=template&id=5ab04145&scoped=true"
import script from "./UploadOrRecordVideo.vue?vue&type=script&lang=js"
export * from "./UploadOrRecordVideo.vue?vue&type=script&lang=js"
import style0 from "./UploadOrRecordVideo.vue?vue&type=style&index=0&id=5ab04145&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab04145",
  null
  
)

export default component.exports